import React, { useState, useEffect, useContext } from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Form, FormControl, MenuItem, Select } from "@mui/material";
import useStyles from "dan-components/SocialMedia/jss/cover-jss";
import Services from "../../../Services/Services";
import MainContext from "../../../Services/Context/MainContext";
import { IVP_AppID } from "../../../api/apps/commonData";
import Swal from "sweetalert2";

function RequestToInstituteByUser({
  props,
  allInstitutelist,
  userId,
  requestInstituteStatus,
  remarks,
  instituteNameafterMapped,
  isDeletedUser,
}) {
  const [open, setOpen] = React.useState(false);
  const { classes } = useStyles();
  const [getErrorMsg, setErrorMsg] = React.useState({});
  const [error, setError] = React.useState({});

  const allContextDetails = useContext(MainContext);

  const initialState = {
    fields: {},
    errors: {},
  };

  const [requestDetails, setRequestDetails] = React.useState(initialState);
  // console.log("ivp add id", IVP_AppID);

  const addRewardByActivity = async () => {
    const bodyjson = {
      app: IVP_AppID,
      userid: allContextDetails.id,
      activity: "Requested successfully for institute coordinator",
      reward_point: "100",
    };
    try {
      const res = await Services.addRewardPointsByActivity(bodyjson);
      // console.log("add reward", res);
    } catch (error) {
      console.log("add reward err", error);
    }
  };

  const handleChange = (e) => {
    let fields = requestDetails.fields;
    fields[e.target.name] = e.target.value;
    setRequestDetails({ ...requestDetails, fields });
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const validateForm = () => {
    let fields = requestDetails.fields;
    let errors = {};
    let formIsValid = true;

    if (!fields["institute"]) {
      formIsValid = false;
      errors["institute"] = "*Please select an Institute";
    }
    setError(errors);
    return formIsValid;
  };

  const handleSubmit = (e) => {
    // console.log("error", requestDetails, initialState);
    // console.log("eeeeeeeeee", error);

    e.preventDefault();
    if (validateForm()) {
      let bodyjson = {
        userid: `${userId}`,
        institute: requestDetails.fields.institute,
      };

      Services.requestToInstituteCoordinator(bodyjson)
        .then(async (response) => {
          // console.log("resquest response", response);
          if (response.status === 200) {
            Swal.fire({
              title: "Success!",
              text: `${response.data.message}`,
              icon: "success",
            }).then(() => {
              addRewardByActivity();
              window.location.reload();
            });
          } else {
            Swal.fire({
              title: "Warning!",
              text: `${response.data.message}`,
              icon: "warning",
            });
          }
          setOpen(false);
        })
        .catch((error) => {
          const errorMsg = error.response.data?.message;
          // console.log("request Error", errorMsg);
          setErrorMsg(errorMsg);
          let errorMessage = "";
          Object.keys(errorMsg).forEach(([field, value]) => {
            errorMessage += errorMsg[field] + "\n";
          });
          if (
            err.response.status === 400 ||
            err.response.status === 500 ||
            err.response.status === 501
          ) {
            Swal.fire({
              title: "Error",
              text: errorMessage,
              icon: "error",
            });
          }
        });
    }
  };

  return (
    <div>
      <div onClick={handleClickOpen}>Join Institute</div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          Request To Join Institute
        </DialogTitle>
        {requestInstituteStatus === "pending" ? (
          <>
            <div>
              <p className="text-center text-red text-danger">
                * You Request is still pending, Kindly Wait for the approval
                from Admin
              </p>
            </div>
          </>
        ) : (
          ""
        )}

        {requestInstituteStatus === "rejected" ? (
          <>
            <div className="text-center">
              <p>Reason to reject by Admin </p>
              <span className="text-danger">{remarks && remarks}</span>
              <p>Contact Admin for more information</p>
            </div>
          </>
        ) : (
          ""
        )}
        {requestInstituteStatus === "approved" ? (
          <>
            <div className="text-center">
              <p className="p-2">
                Your Request is{" "}
                <span className="text-success font-weight-bold">
                  &nbsp;accepted
                </span>
                by admin, Now you are user of
                <br></br>
                <b className="text-success">{instituteNameafterMapped}</b>
              </p>
            </div>
          </>
        ) : (
          ""
        )}

        <form onSubmit={(e) => handleSubmit(e)}>
          <DialogContent>
            <div>
              <FormControl variant="standard" className={classes.formControl}>
                <select
                  className={classes.formSelectRequest}
                  variant="standard"
                  name="institute"
                  onChange={handleChange}
                >
                  <option>- Select Institute</option>
                  {allInstitutelist.map((getInstituteInfo) => {
                    const { id, institute_name } = getInstituteInfo;
                    return (
                      <>
                        <option value={id} key={id}>
                          {getInstituteInfo.institute_name}
                        </option>
                      </>
                    );
                  })}
                </select>
                {error && error.institute && (
                  <div className="text-danger">{error.institute}</div>
                )}
              </FormControl>
            </div>
          </DialogContent>

          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Cancel
            </Button>

            {requestInstituteStatus === "pending" ||
            requestInstituteStatus === "rejected" ||
            requestInstituteStatus === "approved" ||
            requestInstituteStatus === "NotRequested" ? (
              <>
                <Button type="submit" color="primary" disabled>
                  Send
                </Button>
              </>
            ) : (
              <>
                <Button type="submit" color="primary">
                  Send
                </Button>
              </>
            )}

            {/* <Button type="submit" color="primary">
              Send
            </Button> */}
          </DialogActions>
        </form>
      </Dialog>
    </div>
  );
}

export default RequestToInstituteByUser;
